/**
 * Created by stonewang on 2017/8/15.
 */
import React from 'react';
import { hashHistory } from 'react-router';
import { Form, Input, Button, Row, Col, DatePicker, Select, Table, Upload, message, Icon } from 'antd';
import moment from 'moment';
import { DmsTab, SelectRange } from 'Components';
import { openNotice, APIS } from 'Utils';
import ProductModal from '../inventory/productModal';
import { addPaymentList, secondClientList } from '../../service/financialMgm';
const FormItem = Form.Item;

class PaymentAdd extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      opts: ['应付'],
      btnLoad: false,
      detail: {
        productId: '',
        price: ''
      },
      endOpen: false, // 控制失效时间选择
      promotionActivityType: [
        { key: 0, sKey: '返利', name: '返利' },
        { key: 1, sKey: '佣金', name: '佣金' },
        { key: 2, sKey: '退货', name: '退货' },
        { key: 5, sKey: '其他', name: '其他' }
      ],
      clientList: [],  // 客户列表
      informationProps: { // 上传附件
        name: 'file',
        action: APIS.upload,
        headers: {
          authorization: 'authorization-text',
        },
        data: {
          id: '-6',
          dealType: '6'
        },
        onChange: this.updateInformation.bind(this),
      },
      searchObj: {
        s: 10000,
        p: 1
      },
      informationLi: []  // 已上传的附件 List
    }
  }

  /*上传附件*/
  updateInformation(result) {
    let informationLi = this.state.informationLi || [];
    // informationLi = informationLi.slice(-1);    //控制上传数量
    if (result.file.status === 'done') {
      let responseData = result.file.response || {};
      if (responseData.code != 200) {
        openNotice('error', '附件上传失败');
        return;
      }
      informationLi.push({
        id: responseData.data.id,
        fileName: responseData.data.fileName,
      });
    }
    this.setState({
      informationLi: informationLi
    })
  };

  goBack = () => {
    hashHistory.goBack();
  };

  disabledStartDate = (startValue) => {
  }
  disabledEndDate = (endValue) => {
  }
  handleStartOpenChange = (open) => {
    if (!open) {
      this.setState({ endOpen: true });
    }
  }
  handleEndOpenChange = (open) => {
    this.setState({ endOpen: open });
  }

  /* 提交 */
  addSubmit() {
    // console.log(this);
    const { validateFields, getFieldsValue, /* getFieldValue*/ } = this.props.form;
    const informationLi = this.state.informationLi;
    this.props.form.validateFields((err, fieldsValue) => {
      if (!err) {
        // console.log('Received values of form: ', values);
        const values = {
          ...fieldsValue,
          riskDate: fieldsValue.riskDate ? fieldsValue.riskDate.format('YYYY-MM-DD HH:mm:ss') : ''
        }
        // console.log(values);
        // console.log(informationLi);
        let attachmentDto = informationLi.map(x => {
          return { attachId: x.id }
        })
        // console.log(attachmentDto);
        let _params = { ...values, attachmentDto };
        // console.log(_params);
        addPaymentList(_params).then(result => {
          openNotice('success', '新增成功', '');
          this.goBack();
        });
      } else {
        console.log('Error Messages: ', err);
        return
      }
    });
  }

  /*获取列表数据*/
  initData() {
    var obj = this.state.searchObj;
    secondClientList(obj).then(result => {  // 获取客户列表
      // console.log(result);
      if (result.status) {
        this.setState({
          clientList: result.data
        })
      } else {
        message.error(result.message);
      }
    })
  }

  componentDidMount() {
    this.initData();
    //设置离开当前路由时的钩子函数
    // this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
  }

  render() {
    const { opts, detail, promotionActivityType, btnLoad, endOpen, clientList, informationProps } = this.state;
    const { getFieldDecorator } = this.props.form;
    const props = {
      name: 'file',
      action: '//jsonplaceholder.typicode.com/posts/',
      headers: {
        authorization: 'authorization-text',
      },
      onChange(info) {
        if (info.file.status !== 'uploading') {
          console.log(info.file, info.fileList);
        }
        if (info.file.status === 'done') {
          message.success(`${info.file.name} file uploaded successfully`);
        } else if (info.file.status === 'error') {
          message.error(`${info.file.name} file upload failed.`);
        }
      },
    };
    let self = this;
    const inputWidth = {
      width: 300
    };
    const mt = {
      marginTop: 10
    };
    const formItemLayout = {
      labelCol: { span: 5 },
      wrapperCol: { span: 14 },
    };
    return <div>
      <DmsTab options={opts} defaultKey={0}>
        <Button type='primary' loading={btnLoad} onClick={this.addSubmit.bind(this)}>提交</Button>
        <Button onClick={this.goBack}>取消</Button>
      </DmsTab>
      <div className="dms-table-box">
        <Form layout="horizontal">
          <Row gutter={16}>
            <Col className="gutter-row" span={12}>
              <FormItem {...formItemLayout} label="应付日期：">
                {getFieldDecorator('riskDate', {
                  rules: [
                    {
                      required: true,
                      message: '应付日期：'
                    }
                  ],
                })(<DatePicker
                  showTime={false}
                  disabled={detail.id ? true : false}
                  onOpenChange={this.handleStartOpenChange}
                  disabledDate={this.disabledStartDate}
                  format="YYYY-MM-DD HH:mm:ss" style={inputWidth} />)}
              </FormItem>
            </Col>
            <Col className="gutter-row" span={12} id="clientId">
              <FormItem {...formItemLayout} label="客户名称">
                {getFieldDecorator('cusId', {
                  rules: [
                    {
                      required: true,
                      message: '请选择客户名称'
                    }
                  ],
                })(<Select
                  showSearch
                  allowClear
                  multiple={false}
                  disabled={detail.id ? true : false}
                  style={{ width: '300px' }}
                  placeholder="请选择客户名称"
                  optionFilterProp="desc"
                  getPopupContainer={() => document.getElementById('clientId')}
                >
                  {
                    clientList.map((item, key) => {
                      return (
                        <Select.Option key={key + ''} value={item.id + ''} desc={item.name}>{item.name}</Select.Option>
                      )
                    })
                  }
                </Select>)}
              </FormItem>
            </Col>
          </Row>
          <Row gutter={16} style={mt}>
            <Col className="gutter-row" span={12} id="classifyId">
              <FormItem {...formItemLayout} label="费用类型：">
                {getFieldDecorator('riskType', {
                  rules: [
                    {
                      required: true,
                      message: '请选择费用类型：'
                    }
                  ],
                })(<Select
                  showSearch
                  allowClear
                  multiple={false}
                  disabled={detail.id ? true : false}
                  style={{ width: '300px' }}
                  placeholder="请选择费用类型"
                  optionFilterProp="desc"
                  getPopupContainer={() => document.getElementById('classifyId')}
                >
                  {
                    promotionActivityType.map((item, key) => {
                      return (
                        <Select.Option key={key + ''} value={item.sKey + ''}
                                       desc={item.name}>{item.name}</Select.Option>
                      )
                    })
                  }
                </Select>)}
              </FormItem>
            </Col>
            <Col className="gutter-row" span={12}>
              <FormItem {...formItemLayout} label="应付金额：">
                {getFieldDecorator('riskCountShould', {
                  rules: [
                    {
                      required: true,
                      message: '请输入应付金额'
                    }
                  ],
                })(<Input placeholder="请输入应付金额" type="text" style={inputWidth} />)}
              </FormItem>
            </Col>
          </Row>
          <Row gutter={16} style={mt}>
            <Col className="gutter-row" span={22}>
              <FormItem label="备注：">
                {getFieldDecorator('remark', {
                  initialValue: (detail !== null && detail.remark) ? detail.remark : '',
                  rules: [
                    {
                      required: false,
                      message: '请输入备注'
                    }
                  ],
                })(<Input.TextArea />)}
              </FormItem>
            </Col>
          </Row>
          <Row gutter={16} style={mt}>
            <Col className="gutter-row">
              <label>附件：</label>
              <Upload {...informationProps}>
                <Button>
                  <Icon type="upload" /> 上传
                </Button>
              </Upload>
            </Col>
          </Row>
        </Form>
      </div>
    </div>
  }
}
;
// export default PaymentAdd;
export default Form.create()(PaymentAdd);


// WEBPACK FOOTER //
// ./src/routes/financialMgm/paymentAdd.js